import React, { useState, useRef, useLayoutEffect } from "react";
import { useSpring, animated } from "@react-spring/web";
import HandIcon from "../../../../common/logos/HandIcon";

export default function TouchIcon({showWin}) {
  const parentRef = useRef(null);
  const [toggle, setToggle] = useState(false);
  const [touchStartPosition, setTouchStartPosition] = useState(null);

  const { x } = useSpring({
    from: { x: -50, opacity: 0 },
    to: { x: toggle ? 50 : -50, opacity: toggle ? 0 : 1 },
    config: {
      tension: 20,
      friction: 5,
    },
    onRest: () => setToggle(!toggle),
  });

  const handleClick = () => {
    // Hide the touchIconbox when clicked
    const touchIconbox = document.querySelector(".touchIconbox");
    if (touchIconbox) {
      touchIconbox.style.display = "none";
    }
    setToggle(!toggle);
  };

  const handleTouchStart = (event) => {
    // Hide the touchIconbox when touch event starts
    const touchIconbox = document.querySelector(".touchIconbox");
    if (touchIconbox) {
      touchIconbox.style.display = "none";
    }

    const touchX = event.touches[0].clientX;
    setTouchStartPosition(touchX);
  };

  const handleTouchMove = (event) => {
    if (touchStartPosition !== null) {
      const touchX = event.touches[0].clientX;
      const touchDistance = touchX - touchStartPosition;
      if (touchDistance > 50) {
        setToggle(true);
      }
      setTouchStartPosition(null);
    }
  };



  return (
    <div
      style={{}}
      className="touchIconbox"
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >

      {/* wrapping hand icon in animation */}
      <animated.div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transform: x.to((x) => `translateX(${x}px)`),
        }}
      >
        <div>
          <HandIcon
            color={"white"}
            width={"20vw"}
            height={"20vh"}
            outline={30}
            strokeColour={"black"}
          />
        </div>
      </animated.div>
    </div>
  );
}

